import { Button } from "@mui/material";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/Delete";
import DownloadOutlinedIcon from "@mui/icons-material/Download";
import EditOutlinedIcon from "@mui/icons-material/Edit";
import OutlinedFlagIcon from "@mui/icons-material/Flag";
import styles from "./selected_file_buttons.module.css";
import { get } from "util/requests";
import axios from "axios";
import { api_url, corelab_api_url } from "config";

export default function SelectedFileButtons(props) {
  const { selectedFiles, initDelete, setRenameModalIsOpen, blockDelete, blockRename, from_module_bar, showFlagsModal } =
    props;
  const show_rename_button = () => {
    return selectedFiles.length === 1 && selectedFiles[0].type !== "site_folder" && !blockRename && !from_module_bar;
  };
  const show_download_button = () => {
    return selectedFiles.length <= 5 && selectedFiles.filter((f) => f.type !== "file").length === 0;
  };
  const show_flags_button = () => {
    return selectedFiles.length === 1 && selectedFiles[0].type === "file";
  };
  const show_delete_button = () => {
    return (
      selectedFiles.length === 1 &&
      // selectedFiles[0].type === "file" &&
      !blockDelete
    );
  };

  if (selectedFiles.length === 0) return null;

  const download = async () => {
    const _selected = [...selectedFiles];

    async function _downloadFile() {
      if (_selected.length === 0) {
        return;
      }

      let file = _selected.pop();
      let ret = await get(`${corelab_api_url}/presigned_url?file_id=${file.aws_key}`);

      const link = document.createElement("a");
      link.href = ret.data.url;
      link.setAttribute("download", file.name);
      link.setAttribute("id", file.name);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      setTimeout(_downloadFile, 500);
    }
    _downloadFile();
  };
  return (
    <div>
      {show_delete_button() ? (
        <Button className={styles.button} onClick={() => initDelete()}>
          <DeleteOutlineOutlinedIcon sx={{ fontSize: "18px", marginBottom: "2px" }} />
          <div>Delete</div>
        </Button>
      ) : null}
      {show_download_button() ? (
        <Button className={styles.button} onClick={download}>
          <DownloadOutlinedIcon sx={{ fontSize: "20px", marginBottom: "0px" }} />
          Download
        </Button>
      ) : null}
      {show_rename_button() ? (
        <Button
          className={styles.button}
          onClick={() => {
            setRenameModalIsOpen(true);
          }}
        >
          <EditOutlinedIcon sx={{ fontSize: "18px", marginBottom: "2px", marginRight: "2px" }} />
          Rename
        </Button>
      ) : null}
      {show_flags_button() ? (
        <Button
          className={styles.button}
          onClick={() => {
            showFlagsModal(true);
          }}
        >
          <OutlinedFlagIcon sx={{ fontSize: "18px", marginBottom: "2px", marginRight: "2px" }} />
          Flags
        </Button>
      ) : null}
    </div>
  );
}
